export type FlowRunError = {
  readonly flowRunErrorCode: number;
  readonly errorObjectId?: string;
  readonly errorObjectName?: string; // The name of the node/connection that the error is from
  readonly errorObjectType?: string; // Connection or Node
  readonly errorMessageParams?: ReadonlyArray<string>;
  readonly userFriendlyErrorMessage?: string;
};

export function FlowRunErrorUniqueKey(error: FlowRunError): string {
  return  error.errorObjectId != null ? error.flowRunErrorCode + ':' : '' +
          error.errorObjectType != null ? error.errorObjectType + ':' : '' +
          error.flowRunErrorCode;
}
